import { render, staticRenderFns } from "./approveTicketFcp.vue?vue&type=template&id=41670716&lang=pug"
import script from "./approveTicketFcp.vue?vue&type=script&lang=js"
export * from "./approveTicketFcp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports